import Feedback from "./feedback";
export { default as feedbackStyles } from "./feedback.module.scss";
export default Feedback;
